import { ElementRef, Input, Renderer2, Directive, HostBinding } from '@angular/core';
import { BootstrapColor } from '../../global-types';

export type ButtonSize = 'small' | 'default' | 'large';

@Directive({
  selector: '[bpButton], [bpBtn]',
  exportAs: 'bpButton'
})
// tslint:disable-next-line:component-class-suffix
export class BpButtonDirective {
  @Input() color: BootstrapColor = 'primary';
  @Input() outline = false;
  @Input() size: ButtonSize = 'default';
  @Input() block = false;

  @HostBinding('class') public get _class() {
    let cls = 'btn';
    if (this.color && !this.outline) {
      cls += ` btn-${this.color}`;
    } else if (this.color && this.outline) {
      cls += ` btn-outline-${this.color}`;
    }

    if (this.size === 'large') {
      cls += ' btn-lg';
    } else if (this.size === 'small') {
      cls += ' btn-sm';
    }

    if (this.block) {
      cls += ' btn-block';
    }
    return cls;
  }
}
